/* JFK Grocery – FAST cart drawer feedback. Does not modify cart data/prices.
 *
 * Old version problem: it waited for theme drawer markup that does not exist
 * when Slide Cart is the drawer, so the "Loading your cart…" overlay stayed
 * on top of the cart for the full 10-second timeout.
 *
 * This version:
 *  - shows NOTHING when the cart link simply opens the /cart page
 *  - when a drawer opens, hides the overlay the moment the drawer is ready
 *  - never shows longer than 1.2 seconds
 */
(() => {
  'use strict';

  const TRIGGERS =
    '.jfk-header a[aria-label="Cart"], [data-cart-icon-bubble], a[href="/cart"][data-cart-drawer-trigger]';
  const DRAWERS =
    '#slidecarthq, .slidecart, [id*="slidecart" i], [class*="slidecart" i], cart-dropdown-bubble';
  const MAX_WAIT = 1200;

  let overlay = null;
  let timeout = null;
  let observer = null;

  function stop() {
    if (observer) observer.disconnect();
    if (timeout) clearTimeout(timeout);
    observer = timeout = null;
    if (overlay) overlay.remove();
    overlay = null;
  }

  function drawerIsVisible() {
    const drawers = document.querySelectorAll(DRAWERS);
    for (const el of drawers) {
      if (el === overlay) continue;
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      if (
        rect.width > 0 &&
        rect.height > 0 &&
        style.visibility !== 'hidden' &&
        style.display !== 'none' &&
        Number(style.opacity) > 0.5 &&
        el.textContent.trim().length > 0
      ) {
        return true;
      }
    }
    return false;
  }

  function createOverlay() {
    const el = document.createElement('div');
    el.id = 'jfk-cart-wait-indicator';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="jfk-cart-wait-card"><span class="jfk-cart-wait-spinner" aria-hidden="true"></span><strong>Loading your cart…</strong></div>';
    const style = document.createElement('style');
    style.textContent = `
      #jfk-cart-wait-indicator { position:fixed; top:0; right:0; bottom:0; width:min(440px,100vw); z-index:2147483000; pointer-events:none; display:flex; align-items:center; justify-content:center; background:rgba(255,255,255,.9); }
      #jfk-cart-wait-indicator .jfk-cart-wait-card { display:flex; align-items:center; flex-direction:column; gap:12px; color:#193654; font:15px Arial,sans-serif; }
      #jfk-cart-wait-indicator .jfk-cart-wait-spinner { width:40px; height:40px; border:4px solid #e7eedc; border-top-color:#ef531f; border-radius:50%; animation:jfk-cart-wait-spin .7s linear infinite; }
      @keyframes jfk-cart-wait-spin { to { transform:rotate(360deg); } }
    `;
    el.appendChild(style);
    document.body.appendChild(el);
    overlay = el;
  }

  // Lets theme.liquid's Slide Cart callback hide the overlay as soon as items are rendered.
  window.JFKCartLoader = { done: stop };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(TRIGGERS);
      if (!trigger) return;

      // Wait until all click handlers have run. If nobody intercepted the click,
      // the browser is just opening the /cart page – no overlay needed.
      setTimeout(() => {
        if (!event.defaultPrevented) return;
        if (drawerIsVisible()) return; // drawer already open with items – nothing to wait for

        stop();
        createOverlay();

        observer = new MutationObserver(() => {
          if (drawerIsVisible()) setTimeout(stop, 150);
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });

        // Hard cap: never block the cart for more than 1.2 seconds.
        timeout = setTimeout(stop, MAX_WAIT);
      }, 0);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') stop();
  });
  window.addEventListener('pagehide', stop);
})();
